export default {
  App: {
    DarkMode: 'app.darkMode',
    Locale: 'app.locale',
    SwapSlippage: 'app.swapSlippage',
    SwapLiquidity: 'app.swapLiquidity',
    SwapDeadline: 'app.swapDeadline',
    EthereumTxType: 'app.ethereumTxType',
    SupportSignatures: 'app.supportSignatures',
    TermsAccepted: 'app.termsAccepted',
    PoolSorting: 'app.poolSorting',
  },
  Swap: {
    Gasless: 'swap.gasless',
  },
  UserSettings: {
    Currency: 'userSettings.currency',
  },
  TokenLists: {
    Toggled: 'tokenLists.toggled',
  },
  Transactions: 'transactions',
  Alerts: {
    RecoveryExitDismissed: 'alerts.recoveryExitDismissed',
    CultivateAlertAccepted: 'alerts.cultivateAlertAccepted',
  },
};
